import Stamps from './stamps-list';

export default Stamps;
